import React from 'react'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import { TableHeadCell } from './MsgsTable'
import { useTableStyles } from './styles'
import { useTableContext } from '../../context/TableContext'

interface TableHeadProps {
  heads: TableHeadCell[],
  withChecked? :boolean
}

export const TableHeadRender = ({ heads, withChecked }: TableHeadProps) => {
  const classes = useTableStyles()
  const { state: { order, orderBy }, updateState } = useTableContext()

  const handleSort = (property: string) => {
    const isAsc = orderBy === property && order === 'asc'
    updateState({ order: isAsc ? 'desc' : 'asc', orderBy: property })
  }

  return (
    <TableHead>
      <TableRow>
        {withChecked &&
          <TableCell></TableCell>
        }
        {heads.map((headCell) => (
          <TableCell
            className={classes.tablehead}
            key={headCell.id}
            padding="normal"
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.label &&
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={() => handleSort(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
                ) : null}
              </TableSortLabel>
            }
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}
